// Dashboard.js
import React, { useState, useEffect } from "react"
import axios from "axios"
import MovieDetails from "./MovieDetails" // Adjust the path as necessary
import { MOVIES_API_KEY } from "../config/api"
import MovieList from "./MovieList" // Adjust the path as necessary

const MOVIE_KEYWORDS = ["love", "action", "drama", "comedy", "adventure", "mystery", "horror", "sci-fi"]

function Dashboard() {
  const [movie, setMovie] = useState(null)

  useEffect(() => {
    async function fetchMovieOfTheDay() {
      try {
        const randomKeyword =
          MOVIE_KEYWORDS[Math.floor(Math.random() * MOVIE_KEYWORDS.length)]
        const response = await axios.get(
          `https://api.themoviedb.org/3/search/movie?query=${randomKeyword}&api_key=${MOVIES_API_KEY}`
        )
        if (response.data.results.length > 0) {
          const randomMovieIndex = Math.floor(
            Math.random() * response.data.results.length
          )
          const movieOfTheDay = response.data.results[randomMovieIndex]
          //   console.log(movieOfTheDay)
          setMovie(movieOfTheDay) // Set a random movie from the results
        } else {
          console.log("No movies found for this keyword:", randomKeyword)
        }
      } catch (error) {
        console.error("Error fetching the movie of the day: ", error)
      }
    }

    fetchMovieOfTheDay()
  }, [])

  return (
    <div className="container mt-5">
      <h2>Movie of the Day</h2>
      <MovieDetails movie={movie} />
      <MovieList />
    </div>
  )
}


export default Dashboard
